import React from 'react'
import HaulerNext from '../../components/page-content/our-apps/hauler-next'

export const Page = () => {
  return <HaulerNext />
}
export default Page
